<template>
  <div class="stepper-wrapper">
    <div class="input-wrapper">
      <sh-button-deprecated
        ghost
        class="minus"
        size="small"
        :aria-label="$t('ALT_EVENTS_EVENT_REMOVE_LABEL')"
        :disabled="stepperVal === min"
        @click="minus">
          <icon icon="minus-small" />
      </sh-button-deprecated>

      <input
        step="1"
        type="number"
        v-model.number="stepperVal"
        :id="id"
        :min="min"
        :max="max" />

      <sh-button-deprecated
        ghost
        class="plus"
        size="small"
        :aria-label="$t('ALT_EVENTS_EVENT_ADD_LABEL')"
        :disabled="stepperVal === max"
        @click="plus">
          <icon icon="plus-small" />
      </sh-button-deprecated>
    </div>
    <p class="error" v-if="exceedRange">{{ errorMessage }}</p>
  </div>

</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    },
    value: {
      type: Number,
      default: 0
    },
    buttonLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    stepperVal: {
      get () {
        return this.value
      },

      set (newVal) {
        const value = parseInt(newVal, 10)
        this.validateInput(newVal)
        this.$emit('input', value || 0)
      }
    }
  },
  data () {
    return {
      id: null,
      exceedRange: false,
      errorMessage: null,
      errorMin: this.$t('ROOMS_STEPPER_MIN_ERROR', { number: this.min }),
      errorMax: this.$t('ROOMS_STEPPER_MAX_ERROR', { number: this.max })
    }
  },
  methods: {
    minus () {
      if (this.stepperVal > this.min) {
        this.stepperVal = parseInt(this.stepperVal, 10) - 1
      }
    },
    plus () {
      if (this.stepperVal < this.max) {
        this.stepperVal = parseInt(this.stepperVal, 10) + 1
      }
    },
    validateInput (newVal) {
      const regex = /^[0-9]/g
      const regNaN = regex.test(newVal)
      const minRange = newVal < this.min
      const maxRange = newVal > this.max

      if (minRange || maxRange || !regNaN) {
        this.exceedRange = true
        if (minRange) {
          this.errorMessage = this.errorMin
        } else if (maxRange) {
          this.errorMessage = this.errorMax
        }
        return false
      }
      this.exceedRange = false
      return true
    }
  },
  mounted () {
    this.id = `text-input-${uuid()}`
  }
}
</script>

<style lang="scss" scoped>

.stepper-wrapper {
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;

  .input-wrapper {
    display: flex;

    input:focus {
      outline: none;
    }
  }

  label {
    position: absolute;
  }
}

.stepper-wrapper {
  max-width: 160px;

  .input-wrapper {
    align-items: center;

    .ghost {
      height: $d-med-small;
      width: $d-med-small;
      padding: 0 $d-tiny/2;
      margin: $d-tiny/2 $d-tiny;
      border-radius: 4px;
      .icon {
        display: flex;
        flex-direction: column;
        justify-content: center;
        fill: $color-black;
      }

      &:hover:not([disabled]) {
        background-color: $color-white;
        @include shadow("lifted");
      }

      &:active:not([disabled]) {
        .icon {
          fill: lighten($deprecated-f-color-highlight, 20);
        }
      }

      &[disabled] .icon {
        fill: $deprecated-grey-x-dark;
      }
    }

    input {
      @include label-med;
      @include deprecated-f-color-dark;
      width: 72px;
      border: $line-medium;
      background-color: rgba($color-white, 0);
      border-radius: 2px;
      padding: $d-tiny;
      text-align: center;
      @include transition-fast;

      &:focus {
        border: 1px solid $deprecated-brand-tertiary;
        color: $deprecated-brand-secondary;
      }
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      appearance: none;
    }
  }

  .error {
    color: $deprecated-color-ui-error;
    text-align: center;
    width: 100%;
    @include label-xx-sml;
  }

  label {
    @include label-xx-sml;
    top: 100%;
    margin-top: $d-tiny/2;
    text-align: center;
  }
}
</style>
